import { render, staticRenderFns } from "./BulmaCarousel.vue?vue&type=template&id=70621e6b"
import script from "./BulmaCarousel.vue?vue&type=script&lang=js"
export * from "./BulmaCarousel.vue?vue&type=script&lang=js"
import style0 from "./BulmaCarousel.vue?vue&type=style&index=0&id=70621e6b&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70621e6b')) {
      api.createRecord('70621e6b', component.options)
    } else {
      api.reload('70621e6b', component.options)
    }
    module.hot.accept("./BulmaCarousel.vue?vue&type=template&id=70621e6b", function () {
      api.rerender('70621e6b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BulmaCarousel/BulmaCarousel.vue"
export default component.exports